import css from './index.module.scss';
import { useLang } from '@/app/utils/useLang';

const A = () => {
    const { t } = useLang('recall.A');
    return (
        <div className={`${css.page}`}>
            <div className="A-title">
                {t.rich('title', {
                    r: (v: string) => <span style={{ color: 'red' }}>{v}</span>,
                })}
            </div>
            <div className="A-content">
                <div>{t('text1')}</div>
                <div>{t('text2')}</div>
                <div>
                    {t.rich('text3', {
                        b: (v: string) => <span className="fw-700">{v}</span>,
                    })}
                </div>
                <div>
                    {t.rich('text4', {
                        b: (v: string) => <span className="fw-700">{v}</span>,
                        l: (v: string) => (
                            <a className="recall-link" href="https://jp.ecoflow.com/pages/shop-notice" target="_blank" rel="noreferrer">
                                {v}
                            </a>
                        ),
                    })}
                </div>
                <div>
                    {t.rich('text5', {
                        l: (v: string) => (
                            <a
                                className="fw-500 recall-link lh-120"
                                href="https://jp.ecoflow.com/pages/efdelta1300-jp-information"
                                target="_blank"
                                rel="noreferrer"
                            >
                                {v}
                            </a>
                        ),
                    })}
                </div>
                <div>{t('text6')}</div>
                <div className="A-sub-info">
                    <div>
                        {t.rich('text7', {
                            b: (v: string) => <span className="fw-700">{v}</span>,
                        })}
                    </div>
                    <ul className="A-sub-info-list">
                        <li>{t('li1')}</li>
                        <li>{t('li2')}</li>
                        <li>{t('li3')}</li>
                        <li>{t('li4')}</li>
                        <li>{t('li5')}</li>
                        <li>{t('li6')}</li>
                    </ul>
                    <div>
                        {t.rich('text8', {
                            l: (v: string) => (
                                <a
                                    className="recall-link fw-500 lh-120"
                                    href="https://jp.ecoflow.com/pages/product-information"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    {v}
                                </a>
                            ),
                        })}
                    </div>
                </div>
                <div className="A-sign">
                    <div>{t('sign')}</div>
                    <div className="text-left">{t('signTime')}</div>
                    <div className="A-sign-name">
                        <div>{t('sign2')}</div>
                        <div>{t('sign3')}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default A;
